import { render, staticRenderFns } from "./NeedHelp.vue?vue&type=template&id=13c6ab88"
import script from "./NeedHelp.vue?vue&type=script&lang=ts"
export * from "./NeedHelp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports